import gql from 'graphql-tag'

export default gql`
mutation deleteOnboarding ($id: Int!) {
	deleteOnboarding(id: $id) {
		id
	}
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/onboarding/delete.js